
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
import ExportProfit from "@/store/modules/reportstatistics/exportprofit/entity";
@Component
export default class EditExportProfit extends Mixins(FormModalMixins) {
  model = new ExportProfit();
  created() {
    Object.assign(this.config, { modelTitleL: "app.ExportProfit.ProfitRemark", labelWidth: 200, okAction: "reportstatistics/exportprofit/update" });
  }
  get record() {
    return this.$store.state.reportstatistics.exportprofit.editExportProfit;
  }
}
